import React from 'react';

const Step4Terms = ({
  setCurrentStep,
  handleSubmitStep3,
  isSubmitting,
  termsAccepted,
  setTermsAccepted,
  submitError
}) => {
  return (
    <div className="modal_content_body">
      <h3 className="ppt_form_title mb-5 text-center">Step 3: Terms & Conditions</h3>
      <textarea readOnly className='form-control mb-4 border-0' style={{ height: '340px' }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      </textarea>
      <div className="ppt_input_style">
        <div>
          <input
            type="checkbox"
            className="form-checkbox"
            id="ppt_input_checkout_01"
            checked={termsAccepted}
            onChange={e => setTermsAccepted(e.target.checked)}
          />
          <label htmlFor="ppt_input_checkout_01">I accept Terms & Conditions.</label>
        </div>
      </div>
      {submitError && (
        <div className="alert alert-danger mb-4">
          {submitError}
        </div>
      )}
      <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
        <button onClick={() => setCurrentStep(3)} className="ppt_btn_secondary alt text-dark">Back</button>
        <button
          onClick={handleSubmitStep3}
          className="ppt_btn_primary alt"
          disabled={!termsAccepted || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Step4Terms;